export default __webpack_public_path__ + "static/chisel-277ac8dff3272ae1be9beb640ce3b9b5.png";